// extracted by mini-css-extract-plugin
export default {"modalWindow":"RU_wFq8v","mobile":"mobile","title":"xvwmwYxJ","icon":"tjhwNOgk"};